import { render, staticRenderFns } from "./SummitStepTemplate.vue?vue&type=template&id=16b98e06&"
import script from "./SummitStepTemplate.vue?vue&type=script&lang=js&"
export * from "./SummitStepTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports